import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";

var _templateObject, _templateObject2, _templateObject3;

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import cuid from 'cuid';
import styled, { css } from 'styled-components';
import ToggleSwitch from './ToggleSwitch';
import { calculateRem } from '@uie/javascript-style-helpers';
import { colors } from '@vds-core/theme';
import { withVDSManager } from '@vds-core/utilities';

function _calculateBackgroundColor(disabled, on) {
  if (on) {
    return colors.green;
  } else {
    return colors.coolGray3;
  }
}

function _calculateTextColor(disabled, on) {
  if (on) {
    return colors.white;
  } else {
    return colors.black;
  }
}

function _calculateButtonColor(disabled) {
  return colors.white;
}

var propTypes = {
  /**
   * If provided, the toggle will be rendered in the disabled State.
   */
  disabled: PropTypes.bool,

  /**
   * Value given to toggle that will be returned by event handler function given to handleToggle prop.
   */
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,

  /**
   * @ignore
   */
  className: PropTypes.string,

  /**
   * @ignore
   */
  name: PropTypes.string,

  /**
   * If provided, the Toggle will be toggled to its active state.
   */
  on: PropTypes.bool,

  /**
   * Function called on toggle of toggle that returns value assigned to toggle.
   */
  onChange: PropTypes.func,

  /**
   * If set, the On/Off text inside the toggle will be hidden.
   */
  hideText: PropTypes.bool,

  /**
   * @deprecated
   */
  activeLabel: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),

  /**
   * @deprecated
   */
  inactiveLabel: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),

  /**
   * @deprecated on
   */
  checked: PropTypes.bool,

  /**
   * @deprecated onChange
   */
  handleToggle: PropTypes.func,

  /**
   * @ignore
   * Boolean that renders an expanded HitArea
   */
  hitArea: PropTypes.bool,

  /**
   * @ignore
   * String that determines size of Toggle, small or large
   */
  size: PropTypes.oneOf(['small', 'large']),

  /**
   * @ignore
   * Object containing strings of colors in hex
   */
  colorConfig: PropTypes.object,

  /**
   * @ignore
   * Function that determines text color of Toggle
   */
  calculateTextColor: PropTypes.func,

  /**
   * @ignore
   * Object that contains font styles
   */
  bodyConfig: PropTypes.object,

  /**
   * @ignore
   * Number that determines font weight
   */
  calculateFontWeight: PropTypes.number,

  /**
   * @ignore
   * Function that determines background color of Toggle
   */
  calculateBackgroundColor: PropTypes.func,

  /**
   * @ignore
   * Function that determines background color of Toggle button
   */
  calculateButtonColor: PropTypes.func,

  /**
   * @ignore
   * String that determines typescale used for on/off labels
   */
  typescale: PropTypes.string,

  /**
   * @ignore
   * Boolean that renders a new focus state
   */
  focusState: PropTypes.bool,

  /**
   * Allows a string to be provided for analytics.
   *
   */
  'data-analyticstrack': PropTypes.string,

  /**
   * Allows a string to be provided for analytics.
   *
   */
  'data-track': PropTypes.string,

  /**
   * Allows a string to be provided for click stream.
   *
   */
  'data-clickstream': PropTypes.string,

  /**
   * Allows a unique ID to be passed to the component.
   *
   */
  id: PropTypes.string,

  /**
   * @ignore
   *
   */
  inverted: PropTypes.bool,

  /**
   * Allows a unique ID to be passed to the input element.
   */
  inputId: PropTypes.string
};
var defaultProps = {
  disabled: false,
  onChange: function onChange() {},
  className: null,
  name: null,
  hideText: false,
  hitArea: false,
  size: 'small',
  colorConfig: colors,
  calculateTextColor: _calculateTextColor,
  calculateBackgroundColor: _calculateBackgroundColor,
  calculateButtonColor: _calculateButtonColor,
  inverted: false
};
var ToggleWrapper = /*#__PURE__*/styled.div.withConfig({
  displayName: "ToggleWrapper",
  componentId: "sc-1wdseu3-0"
})(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  border-radius: ", ";\n  display: inline-block;\n  position: relative;\n  height: ", ";\n  ", ";\n\n  outline: 0;\n"])), calculateRem(16), function (_ref) {
  var size = _ref.size;
  return size === 'small' ? calculateRem(20) : calculateRem(24);
}, function (_ref2) {
  var hasLabels = _ref2.hasLabels;
  return hasLabels && "\n    display: inline-flex;\n    align-items: center;\n    margin: ".concat(calculateRem(0, 16, 16, 0), ";\n    \n  ");
});
var sharedHitAreaStyles = /*#__PURE__*/css(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  height: ", ";\n  left: 50%;\n  position: absolute;\n  transform: translate(-50%, -50%);\n  text-align: center;\n  top: 50%;\n"])), calculateRem(57));
var HitArea = /*#__PURE__*/styled.span.withConfig({
  displayName: "HitArea",
  componentId: "sc-1wdseu3-1"
})(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  ", ";\n  cursor: pointer;\n  display: inline-block;\n  height: ", ";\n  width: 100%;\n"])), sharedHitAreaStyles, calculateRem(44));

var Toggle = /*#__PURE__*/function (_Component) {
  _inherits(Toggle, _Component);

  var _super = _createSuper(Toggle);

  function Toggle(props) {
    var _this;

    _classCallCheck(this, Toggle);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "componentDidUpdate", function (prevProps) {
      if (prevProps.on !== _this.props.on || prevProps.checked !== _this.props.checked) {
        _this.setState({
          on: _this.props.on || _this.props.checked
        });
      }

      if (document.getElementById(_this.toggleId) && document.activeElement === document.getElementById(_this.toggleId)) {
        document.getElementById(_this.focusId).focus();
      }
    });

    _defineProperty(_assertThisInitialized(_this), "handleSwitchClick", function (e, value) {
      if (_this.props.disabled) return;
      if (e.type === 'click' && e.detail !== 0 && _this.state.hovered) document.activeElement.blur();
      if (typeof _this.props.handleToggle !== 'undefined') _this.props.handleToggle(e);

      _this.props.onChange(e, {
        name: _this.props.name,
        value: _this.props.value,
        on: !_this.state.on,
        index: _this.props.index
      });

      !_this.isControlled && _this.setState({
        on: !_this.state.on
      });
    });

    _defineProperty(_assertThisInitialized(_this), "handleSwitchKeypress", function (e) {
      var space = e.keyCode === 32;
      var enter = e.keyCode === 13;
      if ((enter || space) && e.type !== 'click') _this.handleSwitchClick(e);
    });

    _defineProperty(_assertThisInitialized(_this), "setHoverTrue", function (e) {
      return _this.setState({
        hovered: true
      });
    });

    _defineProperty(_assertThisInitialized(_this), "setHoverFalse", function (e) {
      return _this.setState({
        hovered: false
      });
    });

    _this.toggleId = _this.props.inputId ? _this.props.inputId : cuid();
    _this.focusId = cuid();
    _this.state = {
      on: _this.props.on || _this.props.checked || false,
      hovered: false //hover state is use to check if clicking on the toggle is a real mouse event. screen readers read key events as mouse events, so if its hovered we will know if its really a click.

    };
    return _this;
  }

  _createClass(Toggle, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.isControlled = this.props.on !== undefined || this.props.checked !== undefined;
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          activeLabel = _this$props.activeLabel,
          onProp = _this$props.on,
          checkedProp = _this$props.checked,
          disabled = _this$props.disabled,
          inactiveLabel = _this$props.inactiveLabel,
          value = _this$props.value,
          className = _this$props.className,
          name = _this$props.name,
          onChange = _this$props.onChange,
          hideText = _this$props.hideText,
          hitArea = _this$props.hitArea,
          colorConfig = _this$props.colorConfig,
          calculateTextColor = _this$props.calculateTextColor,
          calculateBackgroundColor = _this$props.calculateBackgroundColor,
          calculateButtonColor = _this$props.calculateButtonColor,
          bodyConfig = _this$props.bodyConfig,
          typescale = _this$props.typescale,
          calculateFontWeight = _this$props.calculateFontWeight,
          size = _this$props.size,
          focusState = _this$props.focusState,
          id = _this$props.id,
          inverted = _this$props.inverted,
          inputId = _this$props.inputId,
          analyticsTrack = _this$props['data-analyticstrack'],
          track = _this$props['data-track'],
          clickStream = _this$props['data-clickstream'];
      var hideInnerText = hideText ? true : false;
      var hasLabels = activeLabel && inactiveLabel ? true : false;
      return /*#__PURE__*/React.createElement(ToggleWrapper, {
        id: id,
        hasLabels: hasLabels,
        className: className,
        colorConfig: colorConfig,
        size: size,
        onMouseOver: this.setHoverTrue,
        onMouseLeave: this.setHoverFalse,
        onClick: this.handleSwitchClick,
        onKeyDown: this.handleSwitchKeypress
      }, hitArea && /*#__PURE__*/React.createElement(HitArea, {
        "data-testid": "test-hitArea",
        onClick: disabled ? null : function (e) {
          return _this2.handleSwitchClick(e, value);
        }
      }), /*#__PURE__*/React.createElement(ToggleSwitch, {
        "data-testid": "test-toggle",
        name: name,
        value: value,
        on: this.state.on,
        disabled: disabled,
        hideText: hideInnerText,
        tabIndex: disabled ? -1 : 0,
        size: size,
        colorConfig: colorConfig,
        calculateTextColor: calculateTextColor,
        bodyConfig: bodyConfig,
        typescale: typescale,
        calculateBackgroundColor: calculateBackgroundColor,
        calculateFontWeight: calculateFontWeight,
        calculateButtonColor: calculateButtonColor,
        focusState: focusState,
        analyticsTrack: analyticsTrack,
        track: track,
        clickStream: clickStream,
        inverted: inverted,
        inputId: this.toggleId,
        focusId: this.focusId
      }));
    }
  }]);

  return Toggle;
}(Component);

Toggle.propTypes = propTypes;
Toggle.defaultProps = defaultProps;
export default withVDSManager(Toggle);